// ─────────────────────────────────────────────────────────────────
// Sehat AI — ChatBubble Component
// ─────────────────────────────────────────────────────────────────

import React from 'react';
import { SPECIALTY_ICONS, SPECIALTY_LABELS } from '../data/specialties';

export function SystemBubble({ content }) {
  return (
    <div style={{ textAlign: 'center', margin: '8px 0' }}>
      <span style={{ fontSize: 11, color: '#94A3B8', background: '#F1F5F9', padding: '3px 14px', borderRadius: 20 }}>
        {content}
      </span>
    </div>
  );
}

export function TypingBubble() {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 9, marginBottom: 14 }}>
      <Avatar />
      <div style={{ padding: '13px 17px', borderRadius: '20px 20px 20px 5px', background: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.07)', display: 'flex', gap: 5, alignItems: 'center' }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{ width: 8, height: 8, borderRadius: '50%', background: '#FF6B35', animation: `dot 1.1s ease ${i * 0.2}s infinite` }} />
        ))}
      </div>
    </div>
  );
}

function Avatar() {
  return (
    <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#FF6B35,#FBBF24)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19, flexShrink: 0 }}>
      🩺
    </div>
  );
}

function UserAvatar() {
  return (
    <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg,#667EEA,#764BA2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, flexShrink: 0, color: '#fff', fontWeight: 900, fontFamily: "'Nunito',sans-serif" }}>
      आप
    </div>
  );
}

// Strip any markdown formatting Claude occasionally produces despite instructions
function stripMarkdown(text) {
  return text
    .replace(/\*\*(.+?)\*\*/g, '$1')   // **bold**
    .replace(/\*(.+?)\*/g, '$1')        // *italic*
    .replace(/__(.+?)__/g, '$1')        // __underline__
    .replace(/^#{1,6}\s+/gm, '')        // # headings
    .replace(/^[-*]\s+/gm, '')          // - bullet points
    .replace(/^\d+\.\s+/gm, '')         // 1. numbered lists
    .replace(/🥇|🥈|🥉/g, '')          // medal ranking emojis
    .replace(/\n{3,}/g, '\n\n')         // collapse excessive blank lines
    .trim();
}

export default function ChatBubble({ msg }) {
  if (msg.role === 'system') return <SystemBubble content={msg.content} />;

  const isUser = msg.role === 'user';
  const text = isUser ? msg.content : stripMarkdown(msg.content);

  return (
    <div style={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', alignItems: 'flex-end', gap: 9, marginBottom: 14 }}>
      {!isUser && <Avatar />}
      <div style={{ maxWidth: '78%' }}>
        <div style={{
          padding: '12px 16px',
          borderRadius: isUser ? '20px 20px 5px 20px' : '20px 20px 20px 5px',
          background: isUser ? 'linear-gradient(135deg,#FF6B35,#FBBF24)' : '#FFFFFF',
          boxShadow: isUser ? '0 4px 14px rgba(255,107,53,0.28)' : '0 2px 10px rgba(0,0,0,0.07)',
          color: isUser ? '#fff' : '#111827',
          fontSize: 13.5, lineHeight: 1.65,
          fontFamily: "'Nunito',sans-serif", fontWeight: 600,
          whiteSpace: 'pre-wrap',
        }}>
          {text}
        </div>

        {/* Specialty search indicator */}
        {msg.sp && (
          <div style={{ marginTop: 7, display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ height: 1, flex: 1, background: '#F3F4F6' }} />
            <span style={{ fontSize: 11, color: '#FF6B35', fontWeight: 800, background: '#FFF7F5', padding: '3px 11px', borderRadius: 10, border: '1.5px solid #FFD8CC', display: 'flex', alignItems: 'center', gap: 5 }}>
              {SPECIALTY_ICONS[msg.sp]} Searching {SPECIALTY_LABELS[msg.sp]}s...
            </span>
            <div style={{ height: 1, flex: 1, background: '#F3F4F6' }} />
          </div>
        )}
      </div>
      {isUser && <UserAvatar />}
    </div>
  );
}
